import { DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Coupon } from "@/v2/models/coupons.js";
import httpMixin from "@/v2/mixins/http.js";
import productMixin from "@/v2/mixins/products.js";
import companyMixin from "@/v2/mixins/companies.js";
import tiersMixin from "@/v2/mixins/tiers.js";
import mediasMixin from "@/v2/mixins/medias.js";
import productGroupMixin from "@/v2/mixins/product-groups.js";
import { CouponFactory, CouponMapperParameter } from "@/v2/models/coupons";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, productMixin, companyMixin, tiersMixin, mediasMixin, productGroupMixin, mapperMixin],
    data() {
        return {
            couponsUrl: window.bo.couponsUrl,
        };
    },
    methods: {
        _couponMapper(coupon) {
            return {
                id: coupon.id,
                code: coupon.code,
                name: coupon.name,
                description: coupon.description,
                type: coupon.type,
                discount_type: coupon.discount_type,
                discount: coupon.discount,
                point_needed: coupon.point_needed,
                start_at: new Date(coupon.start_at),
                end_at: new Date(coupon.end_at),
                image_id: coupon.image_id,
                quantity: coupon.quantity,
                max_quantity_limit: coupon.max_quantity_limit,
                max_amount_limit: coupon.max_amount_limit,
                max_redemption_limit: coupon.max_redemption_limit,
                min_document_amount: coupon.min_document_amount,
                is_accounts_excluded: coupon.is_accounts_excluded,
                is_products_excluded: coupon.is_products_excluded,
                is_tiers_excluded: coupon.is_tiers_excluded,
                is_redeemable: coupon.is_redeemable,
                is_redemption_required: coupon.is_redemption_required,
                individual_use: coupon.individual_use,
                are_bundles_excluded: coupon.are_bundles_excluded,
                created_by: coupon.created_by,
                created_at: coupon.created_at,
                updated_at: coupon.updated_at,
                tierIds: coupon.tierIds,
                companyIds: coupon.companyIds,
                productIds: coupon.productIds,
                minimum_product_quantity: coupon.minimum_product_quantity,
                maximum_product_quantity: coupon.maximum_product_quantity,
                remaining_product_quantity: coupon.remaining_product_quantity,
                variation_quantity_limit: coupon.variation_quantity_limit,
                variation_quantity_remaining: coupon.variation_quantity_remaining,
                promotion_id: coupon.promotion_id,
                promotion_line_id: coupon.promotion_line_id,
                is_trade_promotion_managed: coupon.is_trade_promotion_managed,
                promotion_code: coupon.promotion_code,
                promotion_version: coupon.promotion_version,
                promotion_detail_url: coupon.promotion_detail_url,
            };
        },

        parseCoupon(coupon) {
            return CouponFactory.construct(this.createMapperParameter(new CouponMapperParameter()), coupon);
        },

        parseCoupons(coupons) {
            let parsedCoupons = [];

            coupons.forEach((couponData) => {
                const coupon = this.parseCoupon(couponData);
                parsedCoupons.push(coupon);
            });

            return parsedCoupons;
        },

        getCoupon(id, payload, success, failure) {
            return this.getData(
                this.couponsUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parseCoupon(response.data));
                },
                failure
            );
        },

        getCoupons(payload, success, failure) {
            return this.getData(
                this.couponsUrl,
                payload,
                (response) => {
                    success(this.parseCoupons(response.data.data), response.data.meta);
                },
                failure
            );
        },

        createCoupon(payload, success, failure) {
            return this.postData(
                this.couponsUrl,
                payload,
                (response) => {
                    success(this.parseCoupon(response.data));
                },
                failure
            );
        },

        updateCoupon(id, payload, success, failure) {
            return this.putData(
                `${this.couponsUrl}/${id}`,
                payload,
                (response) => {
                    success(this.parseCoupon(response.data));
                },
                failure
            );
        },

        createOrUpdateCoupon(id = null, payload, success, failure) {
            if (id == null) {
                return this.createCoupon(payload, success, failure);
            } else {
                return this.updateCoupon(id, payload, success, failure);
            }
        },

        deleteCoupon(id, payload, success, failure) {
            return this.deleteData(
                `${this.couponsUrl}/${id}`,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        deleteCoupons(payload, success, failure) {
            return this.postBulkData(
                this.couponsUrl,
                null,
                null,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        refreshCoupon(id, coupons, success, failure) {
            this.getCoupon(
                id,
                this.couponsUrl,
                null,
                (coupon) => {
                    coupons[id] = coupon;
                    if (success) success(coupon);
                },
                failure
            );
        },

        getConsumerCoupons(payload, success, failure) {
            this.getData(
                this.couponsUrl + "/consumerCoupon",
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        getConsumerRedeemableCoupons(payload, success, failure) {
            this.getData(
                this.couponsUrl + "/consumerRedeemableCoupon",
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        postRedeemCoupon(id, payload, success, failure) {
            return this.postData(
                this.couponsUrl + "/redeem/" + id,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        postApplyCoupons(payload, success, failure) {
            return this.postData(
                this.couponsUrl + "/apply",
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },
    },
};
